import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * Migration to remove `modelAliasHistory` as the fields have changed.
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v46 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v46Projects(prevState.projects);
  }

  return nextState;
};

const v46Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(
    ([
      projectId,
      {
        publishHistory: { modelAliasHistory: _, ...publishHistory },
        ...project
      },
    ]) => {
      projectsById[projectId] = {
        ...project,
        publishHistory,
      };
    }
  );

  return { ...prevProjectsState, projectsById };
};
